import type { Users } from '~/types';

export function isAdmin(user: Users.FullUser | Users.GuestUser): boolean {
  return (
    (user && 'account' in user && user.account && user.account.id === 92) ||
    ('email' in user && user.email === 'support@nerdydata.com')
  );
}
